import { useState } from "react";
import { useNavigate } from "react-router-dom";
import RiraLogo from "../Components/RiraLogo";

const API = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email,   setEmail]   = useState("");
  const [loading, setLoading] = useState(false);
  const [result,  setResult]  = useState(null);
  const [error,   setError]   = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res  = await fetch(`${API}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      setResult(data);
    } catch {
      setError("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#FAFAFA",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px 16px",
    }}>
      <div style={{
        background: "#FFFFFF",
        borderRadius: 18,
        border: "1px solid #E0E0E0",
        boxShadow: "0 4px 32px rgba(0,0,0,0.08)",
        padding: "36px 36px 32px",
        width: "100%",
        maxWidth: 420,
        position: "relative",
      }}>
        {/* Close button */}
        <button
          onClick={() => navigate("/auth")}
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#888",
            padding: 6,
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background 0.15s, color 0.15s",
          }}
          onMouseEnter={e => { e.currentTarget.style.background = "#F0F0F0"; e.currentTarget.style.color = "#1A1A1A"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = "#888"; }}
          aria-label="Back to sign in"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {/* Logo */}
        <div style={{ marginBottom: 28, cursor: "pointer" }} onClick={() => navigate("/")}>
          <RiraLogo size={34} />
        </div>

        {!result ? (
          <>
            <div style={{ fontSize: "1.25rem", fontWeight: 800, color: "#1A1A1A", marginBottom: 8, letterSpacing: "-0.3px" }}>
              Reset your password
            </div>
            <p style={{ fontSize: "0.88rem", color: "#666", marginBottom: 24, lineHeight: 1.6 }}>
              Enter your account email and we'll generate a reset code for you.
            </p>
            <form className="auth-form fp-light" onSubmit={handleSubmit}>
              <div className="auth-field">
                <label>Email</label>
                <input
                  type="email"
                  placeholder="you@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
              </div>
              {error && <div className="auth-error">{error}</div>}
              <button type="submit" className="auth-submit" disabled={loading}>
                {loading ? <span className="auth-spinner" /> : "Send Reset Code"}
              </button>
            </form>
            <p style={{ marginTop: 16, textAlign: "center" }}>
              <button className="auth-link-btn" onClick={() => navigate("/auth")}>
                Back to Sign In
              </button>
            </p>
          </>
        ) : (
          <div className="forgot-result">
            <div className="forgot-result-title">Reset code generated</div>
            <p className="forgot-result-note">
              Copy the code below and use it on the reset password page.
              In production, this would be sent to your email.
            </p>
            {result.reset_code && (
              <div className="forgot-token-box">{result.reset_code}</div>
            )}
            <button
              className="auth-submit"
              style={{ marginTop: 20 }}
              onClick={() => navigate(`/reset-password?email=${encodeURIComponent(email)}`)}
            >
              Continue to Reset Password
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
